import React, { useState } from "react";
import { login } from "../utils/api"; // ✅ centralized API call

function Login({ onLoginSuccess }) {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // ✅ Use centralized API helper
      const res = await login(formData.username, formData.password);

      if (res.success) {
        // ✅ Save session info
        sessionStorage.setItem("loggedIn", "true");
        sessionStorage.setItem("role", res.role || "user");
        if (res.user?.username) {
          sessionStorage.setItem("username", res.user.username);
        }

        // ✅ Handle forced password change
        if (res.forceChange) {
          window.location.href = "/change-password";
          return;
        }

        // ✅ Redirect to admin landing page
        if (onLoginSuccess) {
          onLoginSuccess(res.role);
        } else {
          window.location.href = "/admin";
        }
      } else {
        setError(res.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5 pt-4">
      <div className="row justify-content-center">
        <div className="col-md-6 col-sm-12">
          <h2 className="mb-4 text-center">Admin Login</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="username" className="form-label">
                Username
              </label>
              <input
                type="text"
                id="username"
                name="username"
                className="form-control"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>

          {error && <p className="mt-3 text-danger text-center">{error}</p>}
        </div>
      </div>
    </div>
  );
}

export default Login;
